const mediaItems = [
  {
    id: 'highlight-1',
    title: '歌手2024 舞台高光',
    duration: '04:32',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=singer%20on%20stage%20with%20dramatic%20golden%20spotlight%2C%20emotional%20performance%20moment%2C%20concert%20atmosphere%20with%20audience%20lights%2C%20warm%20cinematic%20lighting%2C%20music%20show%20climax%2C%20editorial%20photography&width=600&height=400&seq=media-highlight-1&orientation=landscape',
  },
  {
    id: 'highlight-2',
    title: '奔跑吧 爆笑名场面',
    duration: '03:15',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=funny%20game%20moment%20with%20people%20laughing%20outdoors%2C%20colorful%20reality%20show%20scene%2C%20bright%20sunny%20day%2C%20entertaining%20group%20activity%2C%20warm%20natural%20lighting%2C%20editorial%20style&width=600&height=400&seq=media-highlight-2&orientation=landscape',
  },
  {
    id: 'highlight-3',
    title: '脱口秀大会 犀利吐槽',
    duration: '05:48',
    views: '203万',
    img: 'https://readdy.ai/api/search-image?query=comedian%20on%20stage%20with%20microphone%20delivering%20punchline%2C%20stand-up%20comedy%20atmosphere%20with%20audience%20reaction%2C%20warm%20spotlight%2C%20intimate%20venue%2C%20entertainment%20photography&width=600&height=400&seq=media-highlight-3&orientation=landscape',
  },
  {
    id: 'highlight-4',
    title: '街舞总决赛 炸裂Battle',
    duration: '06:20',
    views: '157万',
    img: 'https://readdy.ai/api/search-image?query=dance%20battle%20with%20dynamic%20movement%20and%20dramatic%20lighting%2C%20street%20dance%20competition%20final%2C%20energetic%20performance%20on%20stage%2C%20warm%20golden%20spotlights%2C%20editorial%20style&width=600&height=400&seq=media-highlight-4&orientation=landscape',
  },
  {
    id: 'highlight-5',
    title: '密室大逃脱 恐怖特辑',
    duration: '07:05',
    views: '89万',
    img: 'https://readdy.ai/api/search-image?query=dimly%20lit%20mysterious%20room%20with%20warm%20candle-like%20lighting%20and%20puzzle%20props%2C%20immersive%20escape%20room%20experience%2C%20suspenseful%20atmosphere%2C%20cinematic%20mystery%20style%2C%20editorial%20photography&width=600&height=400&seq=media-highlight-5&orientation=landscape',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            精彩片段
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            精选综艺高光时刻，快速浏览最精彩瞬间
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={`极速影院${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/70 text-background-50 text-[10px] font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-bold text-foreground-950 font-heading leading-snug">
                  {item.title}
                </h3>
                <p className="mt-1 text-[11px] text-foreground-500">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}